import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const toggleLanguage = () => {
    const newLang = currentLang === 'zh' ? 'en' : 'zh';
    i18n.changeLanguage(newLang);
    localStorage.setItem('aligcus_lang', newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-gray-300 hover:border-red-600 text-gray-700 hover:text-red-600 transition-all duration-200 text-sm font-medium"
      data-testid="language-toggle"
    >
      <Globe className="w-4 h-4" />
      <span>{currentLang === 'zh' ? 'EN' : '中文'}</span>
    </button>
  );
};

export default LanguageToggle;
